import { render, staticRenderFns } from "./ProgressCourse.vue?vue&type=template&id=0ffa207f"
import script from "./ProgressCourse.vue?vue&type=script&lang=js"
export * from "./ProgressCourse.vue?vue&type=script&lang=js"
import style0 from "./ProgressCourse.vue?vue&type=style&index=0&id=0ffa207f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports